/** Shared types for /account/users/* endpoints. */

export interface AccountUser {
  id: number;
  first_name?: string;
  last_name?: string;
  full_name?: string;
  email?: string;
  avatar_url?: string;
  avatar_thumb_url?: string;
  timezone?: string;
  can_host_zoom_meeting?: boolean;
  zoom_plan_type?: number;
  zoom_rate_limit_reached?: boolean;
}

export function accountUserFullName(user: AccountUser): string {
  if (user.full_name?.trim()) return user.full_name.trim();
  const first = user.first_name?.trim() ?? '';
  const last = user.last_name?.trim() ?? '';
  return `${first} ${last}`.trim() || user.email || `User ${user.id}`;
}
